import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AdminLayout from "components/admin/layout"
import Button from "components/inputs/button"
import memo from "set-state-compare/build/memo"
import React from "react"
import Routes from "shared/routes"
import {ScoreFactor} from "models"
import ScoreFactorsTable from "components/score-factors/table"
import useCanCan from "@kaspernj/api-maker/build/use-can-can"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"

/** @typedef {object} RoutesAdminScoreFactorsIndexProps */

/** @typedef {object} RoutesAdminScoreFactorsIndexState */

/**
 * @extends {ShapeComponent<RoutesAdminScoreFactorsIndexProps, RoutesAdminScoreFactorsIndexState>}
 */
class RoutesAdminScoreFactorsIndex extends ShapeComponent {
  setup() {
    const {t} = useI18n({namespace: "js.routes.admin.score_factors.index"})

    const canCan = useCanCan(() => [[ScoreFactor, ["create"]]])

    this.canCan = canCan
    this.t = t
  }

  render() {
    return (
      <AdminLayout
        actions={this.actions()}
        active="score-factors"
        className="routes--admin-score-factors--index"
        headerTitle={ScoreFactor.modelName().human({count: 2})}
      >
        <ScoreFactorsTable adminLayout />
      </AdminLayout>
    )
  }

  actions() {
    const {canCan, t} = this.tt

    return (
      <>
        {canCan.can("create", ScoreFactor) &&
          <Button
            className="new-score-factor-button"
            icon="plus"
            label={t(".add_new_score_factor")}
            to={Routes.newAdminScoreFactorPath()}
          />
        }
      </>
    )
  }
}

export default memo(shapeComponent(RoutesAdminScoreFactorsIndex))
